<div class="settings">
  <mat-toolbar color="primary">
    <mat-toolbar-row class="firstRow">
      <button class="headerButton tab-small" mat-button (click)="close()">
        <span class="material-icons">navigate_before</span>
        Back
      </button>
      <button
        class="headerButton tab-like"
        [class.highlight]="showIconSetCustomization | async"
        mat-button
        (click)="openIconSetCustomization()"
      >
        <span class="headline">Customize Icon Set</span>
      </button>
      <button
        class="headerButton tab-like"
        [class.highlight]="showAutosaveSettings | async"
        mat-button
        (click)="openGeneralSettings()"
      >
        <span class="headline">Autosave Settings</span>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  @if (showAutosaveSettings | async) {
    <app-autosave-settings />
  }
  @if (showIconSetCustomization | async) {
    <app-icon-set-configuration />
  }
</div>
